import React, { createContext, useState, useContext } from 'react'

const TechnicalAssistanceContext = createContext()

export const TechnicalAssistanceProvider = (props) => {
  const [assistanceForm, setAssistanceForm] = useState({})

  return (
    <TechnicalAssistanceContext.Provider
      value={{
        assistanceForm,
        setAssistanceForm,
      }}
    >
      {props.children}
    </TechnicalAssistanceContext.Provider>
  )
}

export const useFormTechnicalAssistance = () => {
  const context = useContext(TechnicalAssistanceContext)
  if (context === undefined) {
    throw new Error(
      'useFormTechnicalAssistance can only be used inside FormProvider',
    )
  }
  return context
}
